module.exports = __webpack_public_path__ + "img/ea_bg6.f5b96c63.jpg";